/** Pluralize your text */
export function pluralize(word: string, number: number) {
    return `${word}${number % 10 === 1 && number % 100 !== 11 ? '' : 's'}`;
}
